module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAOCAYAAAAIar0YAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABmSURBVAiZtYyxDUBAAEXfXa4SQ9jBBGorWMAQl5DYwCyEJa42gFJFK74GEb1Xvrw8Qu+30PuWC4eIDcS3sHz4VbhbmNB5ATswg1ncq0jEUT4PoTrNm8ECSIxr5JorNZNkiyyrdoATnXkcwaZOoe0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/px2_act.png
// module id = nJD7
// module chunks = 1